<template>
  <div class="mapMenu">
    <h2 class="normal">地图菜单</h2>
    <div class="mt100">
      <el-button type="primary" @click="toMapPage('板块')">板块图</el-button>
      <el-button type="primary" @click="toMapPage('板块规划')">板块规划</el-button>
      <el-button type="primary" @click="toMapPage('高架')">快速路</el-button>
      <el-button type="primary" @click="toMapPage('板块热力')">热力图</el-button>
    </div>
    <div class="mt100">
      <el-button type="primary" @click="toMapPage('新房','杭州')">新房</el-button>
      <el-button type="primary" @click="toMapPage('待首开','杭州')">待首开和土拍</el-button>
      <el-button type="primary" @click="toMapPage('公示登记','杭州')">公示登记</el-button>
    </div>
    <div class="mt100">
      新房
      <el-button type="primary" v-for="area in areas" :key="area" @click="toMapPage('新房', area)">{{area}}</el-button>
    </div>
    <div class="mt100">
      二手房
      <el-button type="primary" v-for="area in areas" :key="area" @click="toMapPage('二手房', area)">{{area}}</el-button>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        areas: ['杭州', '余杭区', '萧山区', '滨江区', '钱塘新区', '拱墅区', '上城区', '下城区', '富阳区', '江干区', '临安区', '西湖区']
      }
    },

    mounted() {

    },
    methods: {
      toMapPage(type, area) {
        // let newpage = this.$router.resolve({
        //   name: 'location-image',
        //   query: {
        //     type,
        //     area
        //   }
        // })
        // window.open(newpage.href, '_blank');
        let item = {
          type,
          area
        }
        this.$router.push({
          name: 'location-image',
          params: item
        })
      },
    }
  }

</script>

<style scoped>
  .mapMenu {
    text-align: center;
    overflow: hidden;
  }

  .mt100 {
    margin-top: 100px;
  }

</style>



// WEBPACK FOOTER //
// src/page/MapMenu.vue